const reportProject = {
  eval_report_project_list_get: 'eval_report_project_list_get', // 获取项目列表
  eval_report_project_data_export: 'eval_report_project_data_export', // 导出项目数据
  eval_report_project_del: 'eval_report_project_del111', // 删除项目
  eval_report_import: 'eval_report_import' // eval_report_individual_list_get
};

const evalReportIndividual = {
  eval_report_individual_list_get: 'eval_report_individual_list_get' // 获取人员列表
};

export default {
  ...reportProject,
  ...evalReportIndividual,
  data: {
    eval_report_project_list_get_extent: 'eval_report_project_list_get_extent', // 项目维度项目范围
    eval_report_individual_list_get_extent: 'eval_report_individual_list_get_extent' // 个人维度人员范围
  }
};
